import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import AffiliateDisclosure from "./pages/AffiliateDisclosure";

// Skincare Pages
import SkincareLanding from "./pages/skincare/SkincareLanding";
import MorningRoutines from "./pages/skincare/MorningRoutines";
import EveningRoutines from "./pages/skincare/EveningRoutines";
import Acne from "./pages/skincare/Acne";
import DarkSpotsHyperpigmentation from "./pages/skincare/DarkSpotsHyperpigmentation";
import SensitiveSkin from "./pages/skincare/SensitiveSkin";
import SkincareCompare from "./pages/skincare/Compare";

// Makeup Pages
import MakeupLanding from "./pages/makeup/MakeupLanding";
import MakeupEveryday from "./pages/makeup/Everyday";
import MakeupMinimal from "./pages/makeup/Minimal";
import MakeupEssentials from "./pages/makeup/Essentials";
import MakeupCompare from "./pages/makeup/Compare";

// Wellness Pages
import WellnessLanding from "./pages/wellness/WellnessLanding";
import Supplements from "./pages/wellness/Supplements";
import SelfCareEssentials from "./pages/wellness/SelfCareEssentials";
import DailyHealthPicks from "./pages/wellness/DailyHealthPicks";
import WellnessCompare from "./pages/wellness/Compare";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Main Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/affiliate-disclosure" element={<AffiliateDisclosure />} />
        
        {/* Skincare Routes */}
        <Route path="/skincare" element={<SkincareLanding />} />
        <Route path="/skincare/compare" element={<SkincareCompare />} />
        <Route path="/skincare/morning-routines" element={<MorningRoutines />} />
        <Route path="/skincare/evening-routines" element={<EveningRoutines />} />
        <Route path="/skincare/acne" element={<Acne />} />
        <Route path="/skincare/dark-spots-hyperpigmentation" element={<DarkSpotsHyperpigmentation />} />
        <Route path="/skincare/sensitive-skin" element={<SensitiveSkin />} />
        
        {/* Makeup Routes */}
        <Route path="/makeup" element={<MakeupLanding />} />
        <Route path="/makeup/compare" element={<MakeupCompare />} />
        <Route path="/makeup/everyday" element={<MakeupEveryday />} />
        <Route path="/makeup/minimal" element={<MakeupMinimal />} />
        <Route path="/makeup/essentials" element={<MakeupEssentials />} />
        
        {/* Wellness Routes */}
        <Route path="/wellness" element={<WellnessLanding />} />
        <Route path="/wellness/compare" element={<WellnessCompare />} />
        <Route path="/wellness/supplements" element={<Supplements />} />
        <Route path="/wellness/self-care-essentials" element={<SelfCareEssentials />} />
        <Route path="/wellness/daily-health-picks" element={<DailyHealthPicks />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
